import Moment from 'moment';

// Constants
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const REFRESHING_TOKEN = 'REFRESHING_TOKEN';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const UPDATE_ENTIDAD_INFO = 'UPDATE_ENTIDAD_INFO';
export const SET_PERIODO_FISCAL_SELECTED = 'SET_PERIODO_FISCAL_SELECTED';
export const SET_NETPAY_AUTH_DATA = 'AUTH__SET_NETPAY_AUTH_DATA';

const initialState = {
  isAuthenticated: false,
  token: null,
  user: null,
  roles: [],
  refreshToken: null,
  entidad: null,
  periodoFiscalSelected: null,
  netpay: null,
  refreshingToken: false,
};

// Action handlers
const handleLogin = (state, payload) => {
  if (payload) {
    const {
      token,
      refreshToken,
      user,
      roles,
      entidad,
      periodoFiscalSelected,
    } = payload;

    return {
      ...state,
      isAuthenticated: true,
      token,
      refreshToken,
      user,
      roles,
      entidad: {
        ...entidad,
        ...entidad.configuracion,
      },
      periodoFiscalSelected,
    };
  }
  return state;
};

// eslint-disable-next-line arrow-body-style
const handleLogout = () => ({ ...initialState });

const handleRefreshToken = (state, payload) => ({ ...state, token: payload });

const handleUserInfo = (state, payload) => {
  const {
    user,
    roles,
  } = payload;
  if (roles === undefined) {
    return {
      ...state,
      user,
    };
  }
  return {
    ...state,
    user,
    roles,
  };
};

const handleEntidadInfo = (state, payload) => {
  const entidad = { ...payload };
  const { configuracion } = payload;
  delete entidad.configuracion;
  delete entidad.rol_inspector;
  if (configuracion?.id) delete configuracion.id;
  entidad.grupos = entidad.grupos.map(({ permissions, ...g }) => g);
  return {
    ...state,
    entidad: {
      ...configuracion,
      ...entidad,
    },
  };
};

const handlePeriodoFiscal = (st, periodoFiscalSelected) => ({ ...st, periodoFiscalSelected });
const handleRefreshingToken = (st, refreshingToken) => ({ ...st, refreshingToken });

const handleNetPayAuthData = (state, payload) => ({
  ...state,
  netpay: payload ? {
    ...payload,
    expires_at: new Moment().add(payload.expires_in, 's'),
  } : null,
});

const ACTION_HANDLER = {
  [LOGIN]: handleLogin,
  [LOGOUT]: handleLogout,
  [UPDATE_USER_INFO]: handleUserInfo,
  [REFRESH_TOKEN]: handleRefreshToken,
  [UPDATE_ENTIDAD_INFO]: handleEntidadInfo,
  [SET_PERIODO_FISCAL_SELECTED]: handlePeriodoFiscal,
  [SET_NETPAY_AUTH_DATA]: handleNetPayAuthData,
  [REFRESHING_TOKEN]: handleRefreshingToken,
};

export const selectPublicoGeneral = (state) => state.auth.entidad.ciudadano_publico_en_general;

export default (state = initialState, action) => {
  const handler = ACTION_HANDLER[action.type];
  return handler ? handler(state, action.payload) : state;
};
